import { type Socket, io } from 'socket.io-client';

let socket: Socket | null = null;
let socketToken: string | null = null;

/**
 * 单例 WebSocket 连接 — 在登录后调 connect()，登出时 disconnect()
 *
 * 浏览器内仅 1 个 socket 实例，所有 listener 通过 onNotification 注册
 */
export function connectRealtime(token: string): Socket {
  if (socket && socketToken === token) return socket;
  socket?.disconnect();
  socketToken = token;
  // 开发：vite proxy 转发；生产：直连 API host
  const apiUrl = import.meta.env.VITE_API_URL || window.location.origin;
  const nextSocket = io(apiUrl, {
    path: '/v1/realtime',
    transports: ['websocket', 'polling'],
    auth: { token },
    reconnection: true,
    reconnectionDelay: 2_000,
    reconnectionDelayMax: 10_000,
  });
  socket = nextSocket;
  nextSocket.on('connect', () => {
    console.info('[realtime] connected', nextSocket.id);
  });
  nextSocket.on('disconnect', (reason) => {
    console.info('[realtime] disconnected:', reason);
  });
  nextSocket.on('connect_error', (err) => {
    console.warn('[realtime] connect_error:', err.message);
  });
  return nextSocket;
}

export function disconnectRealtime() {
  if (socket) {
    socket.disconnect();
    socket = null;
    socketToken = null;
  }
}

export function getRealtimeSocket(): Socket | null {
  return socket;
}

export interface RealtimeNotification {
  id?: string;
  kind: string;
  title: string;
  body?: string;
  amount?: number;
  result?: 'success' | 'failure';
  targetEntity?: string;
  targetId?: string;
  oaModelId?: string;
  payload?: Record<string, unknown>;
  ts: string;
  readAt?: string;
}
